import { render, staticRenderFns } from "./profitHome.vue?vue&type=template&id=69f27704&scoped=true&"
import script from "./profitHome.vue?vue&type=script&lang=js&"
export * from "./profitHome.vue?vue&type=script&lang=js&"
import style0 from "./profitHome.vue?vue&type=style&index=0&id=69f27704&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f27704",
  null
  
)

export default component.exports